import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  channels: [],
  currentChannel: null,
  loading: false,
  error: null,
}

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setChannels: (state, action) => {
      state.channels = action.payload
      state.loading = false
      state.error = null
    },
    setCurrentChannel: (state, action) => {
      state.currentChannel = action.payload
    },
    addChannel: (state, action) => {
      state.channels.unshift(action.payload)
    },
    updateChannel: (state, action) => {
      const index = state.channels.findIndex(c => c.id === action.payload.id)
      if (index !== -1) {
        state.channels[index] = action.payload
      }
    },
    removeChannel: (state, action) => {
      state.channels = state.channels.filter(c => c.id !== action.payload)
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  setChannels,
  setCurrentChannel,
  addChannel,
  updateChannel,
  removeChannel,
  setLoading,
  setError,
  clearError,
} = notificationSlice.actions

export default notificationSlice.reducer

// Selectors
export const selectChannels = (state) => state.notification.channels
export const selectCurrentChannel = (state) => state.notification.currentChannel
export const selectNotificationLoading = (state) => state.notification.loading
export const selectNotificationError = (state) => state.notification.error
